/**
 * The one formatter for user-facing NOK amounts given in øre (NOK minor
 * units), shared by every price display — the /abonnement price card, the
 * Account → Abonnement price row and the Betalingshistorikk table:
 *
 *   29900 → "299 kr"      whole kroner: no decimals
 *     151 → "1,51 kr"     non-whole: two decimals, nb-NO decimal comma
 *   19950 → "199,50 kr"
 *
 * Deterministic string math on purpose (no Intl): the output cannot vary
 * with the browser's ICU data, and it never rounds øre away — the old
 * `Math.round(priceOre / 100)` turned a 151-øre test price into "2 kr".
 * Mirrors formatNokFromOre in the backend receipt email
 * (coord-backend/src/lib/chargeScheduler.js) so a receipt and the account
 * page can never disagree on an amount.
 *
 * Returns null for anything that is not a finite number, so callers decide
 * their own placeholder (skeleton while /status loads, "–" in a table).
 */
export function formatKr(amountOre) {
  if (typeof amountOre !== 'number' || !Number.isFinite(amountOre)) return null;
  const sign = amountOre < 0 ? '-' : '';
  const abs = Math.abs(Math.round(amountOre));
  const whole = Math.floor(abs / 100);
  const rest = abs % 100;
  return rest === 0
    ? `${sign}${whole} kr`
    : `${sign}${whole},${String(rest).padStart(2, '0')} kr`;
}
